module.exports = __webpack_public_path__ + "img/industries-finance.svg";